import { Component, ElementRef, OnInit, ViewChild, Injector } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from 'src/app/services/loader.service';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { BULK_UPLOAD, COMMON_CONSTANTS } from 'src/app/common/core/common.constants';
import * as _ from 'lodash';
import { UtilsService } from 'src/app/services/utils.service';
import { ChangeServiceService } from 'src/app/services/change-service.service';
import { PDLService } from 'src/app/services/pdl-service.service';
import { CommonBulkUploadComponent } from 'src/app/bulk/components/common-bulk-upload/common-bulk-upload.component';
import { ExportService } from 'src/app/services/export.service';
import { BasicPopupModalComponent } from 'src/app/shared/components/basic-popup-modal/basic-popup-modal.component';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { HttpCacheService } from 'src/app/services/http-cache.service';

@Component({
  selector: 'app-change-service-bulk-selection',
  templateUrl: './change-service-bulk-selection.component.html',
  styleUrls: ['./change-service-bulk-selection.component.scss']
})
export class ChangeServiceBulkSelectionComponent implements OnInit {
  public authoringContentData: any;
  dataServices: any = [];
  otherServices: any = [];
  blockServices: any = [];
  ngbModalOptions: NgbModalOptions;
  currentSelectedServices:any = [];
  @ViewChild('technicalDifficulties') technicalDifficulties: ElementRef;
  public errorModalContent: any;
  templateType: string;

  expPanelHeader: any='';
  manageLineService: ManageLineService;
  _loaderSvc: LoaderService; 
  modalService: NgbModal;
  utilsSvc: UtilsService;
  _changeSvc: ChangeServiceService;
  pdlService: PDLService;
  activeModal: NgbActiveModal;
  exportSvc: ExportService;
  _helperSvc: HelperUtilityService;
  _cacheSvc: HttpCacheService;


  constructor(private injector : Injector) {
    this.manageLineService = this.injector.get<ManageLineService>(ManageLineService);
    this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
    this.modalService = this.injector.get<NgbModal>(NgbModal);
    this.utilsSvc = this.injector.get<UtilsService>(UtilsService);
    this._changeSvc = this.injector.get<ChangeServiceService>(ChangeServiceService);
    this.pdlService = this.injector.get<PDLService>(PDLService);
    this.activeModal = this.injector.get<NgbActiveModal>(NgbActiveModal)
    this.exportSvc = this.injector.get<ExportService>(ExportService);
    this._helperSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
  }


  ngOnInit() {
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      container: '#am-container-custom',
    };
    this.authoringContentData = this.utilsSvc.getContentDataFromSession().changeRatePlan;
    this.errorModalContent = this.utilsSvc.getContentDataFromSession();

    this.servicesApi();
  }

  servicesApi() {
    let data = this._cacheSvc.getFromSessionStorage(BULK_UPLOAD.CATALOG_SERVICE_AGGREGATION_RESP) || {};
    const services = JSON.parse(data);
    this.createServicesListForTable(services);
  }

  createServicesListForTable(response){
    this.eligibleServices(response.catalogDetails);

    this.dataServices = this.sortService(this.dataServices);
    this.blockServices = this.sortService(this.blockServices);
    this.otherServices = this.sortService(this.otherServices);
  }

  eligibleServices(services){
    for (const service of services) {
      if(_.isUndefined(service.isSelected)){
        service.isSelected = false;
      }
      this.groupServices(service);
    }
  }

  groupServices(service){
    if(service.category === COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLK || service.group === COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLOCKING_CAPS){
      this.blockServices.push(service);
    }else if(service.category !== COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLK && service.group === "Data"){
      this.dataServices.push(service);
    }else if(service.category !== COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLK && service.group === "OptionalService"){
      this.otherServices.push(service);
    }
  }

  sortService(categoryArray){
    // on page load sort in alphabetical order - ascending
    let currArray:any=[];
    currArray = _.filter(categoryArray, function(x){ return x.current});
    let eligibleArray:any=[];
    eligibleArray = _.filter(categoryArray, function(x){ return !x.current});
    this.sortArray(currArray);
    this.sortArray(eligibleArray);
    return currArray.concat(eligibleArray);
  }
  sortArray(arrayToSort){
    arrayToSort.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    });
  }

  openViewDetailsModal(serviceDetails){
    const popupRef = this.modalService.open(BasicPopupModalComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      container: '#am-container-custom'
    });
    popupRef.componentInstance.title = serviceDetails.skuName;
    popupRef.componentInstance.message = serviceDetails.features;
  }

  checkServiceSelection(service){
    if (service.isSelected) {
      this.currentSelectedServices.push(service);
    } else {
      this.currentSelectedServices = this.currentSelectedServices.filter((selectedService) => selectedService.sku != service.sku)
    }
  }

  errorCloseButtonTagging(){
    this.manageLineService.close();
  }

  onExpand(expPanelHeader){
    this.expPanelHeader = expPanelHeader;
  }

  onCollapse(expPanelHeader){
    this.expPanelHeader = expPanelHeader;
  }

  downloadChangeServiceFile() {
    this.exportSvc.downloadChangeServiceDynamicTemplate(this.currentSelectedServices, this.templateType);
    this.modalService.dismissAll();
    this.modalService.open(CommonBulkUploadComponent, this.ngbModalOptions);
  }

  close() {
    this.activeModal.dismiss();
  }
}
